import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Manufacturing from "../components/Manufacturing";
import useLoadScripts from '../utils/useLoadScript';
import { MetaTagComponent, MetaTags } from '../utils/MetaTags';

function ManufacturingPage() {
useLoadScripts([
    '/assets/js/jquery-3.7.1.min.js',
    '/assets/js/jquery-ui.js',
    '/assets/js/moment.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/swiper-bundle.min.js',
    '/assets/js/waypoints.js',
    '/assets/js/jquery.counterup.min.js',
    '/assets/js/wow.min.js',
    '/assets/js/jquery.nice-select.min.js',
    '/assets/js/jquery.marquee.min.js',
    '/assets/js/gsap.min.js',
    '/assets/js/ScrollTrigger.min.js',
    '/assets/js/ScrollSmoother.min.js',
    '/assets/js/SplitText.min.js',
    '/assets/js/matter.min.js',
    '/assets/js/throwable-helper.js',  // ← pehle helper
    '/assets/js/Throwable.min.js',     // ← phir Throwable
    '/assets/js/jquery.fancybox.min.js',
    '/assets/js/three.js',
    '/assets/js/hover-effect.umd.js',
    '/assets/js/custom.js',
]);

  return (
  <div id="smooth-wrapper">
    <div id="smooth-content">
      <MetaTagComponent 
        pageTitle={MetaTags.manufacturing.title}
        pageDescription={MetaTags.manufacturing.description}
        pageKeywords={MetaTags.manufacturing.keywords}
      />
      <Header />
      <Manufacturing />
      <Footer />
    </div>
  </div>
); 
}

export default ManufacturingPage;
